module.exports = __webpack_public_path__ + "static/media/favicon.630085bb.ico";